/*
  tns-nach-oben.js — zeigt den Nach-oben-Knopf ab einem eingestellten Scrollweg
  und bringt die Seite zurueck an den Anfang.

  Bewusst klein: kein Framework, kein Abhaengigkeiten, und die Scroll-Abfrage
  laeuft ueber requestAnimationFrame statt bei jedem einzelnen Scroll-Ereignis —
  sonst rechnet der Browser auf langen Produktseiten dauernd mit.
*/
(function () {
  var knopf = document.querySelector('[data-tns-top]');
  if (!knopf) return;

  var ab = parseInt(knopf.getAttribute('data-ab'), 10) || 1500;
  var wartet = false;
  knopf.hidden = false;

  function pruefen() {
    wartet = false;
    var weit = (window.scrollY || document.documentElement.scrollTop) > ab;
    knopf.setAttribute('data-sichtbar', weit ? 'ja' : 'nein');
  }

  function geplant() {
    if (wartet) return;
    wartet = true;
    window.requestAnimationFrame(pruefen);
  }

  window.addEventListener('scroll', geplant, { passive: true });
  pruefen();

  knopf.addEventListener('click', function () {
    var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: sanft ? 'smooth' : 'auto' });
  });
})();
